import React from 'react'
import { Navigate } from 'react-router-dom'
import { useAuthContext } from '@contexts/AuthContext'
import { Box, CircularProgress } from '@mui/material'

interface Props {
  children: React.ReactNode
}

const PublicRoute: React.FC<Props> = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuthContext()

  if (isLoading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
      >
        <CircularProgress size={40} />
      </Box>
    )
  }

  if (isAuthenticated) {
    // Redirect to home page if already authenticated
    return <Navigate to="/" replace />
  }

  return <>{children}</>
}

export default PublicRoute